<template>
  <container>
    <div
      :class="[
        'home-page page w-100 p-0 m-0',
        {
          'home-page--guest': !user
        }
      ]"
    >
      <banner></banner>
      <div class="container">
        <div>
          <h2 class="page-title">Recently Added</h2>
          <recently-added-jobs-list></recently-added-jobs-list>
        </div>
      </div>

      <div class="home__hiw">
        <div class="container">
          <h2 class="page-title pt-4">How It Works</h2>
          <b-row no-gutter class="align-items-center">
            <b-col md="6">
              <b-img-lazy
                fluid-grow
                alt="How it works"
                :src="require('@/assets/images/banners/home-hiw.png')"
                class="banner-img"
              ></b-img-lazy>
            </b-col>
            <b-col md="6">
              <div class="home__hiw__content">
                <div class="d-flex align-items-center">
                  <b-img-lazy
                    alt="Find a tool"
                    :src="require('@/assets/images/search-lg.svg')"
                    v-bind="hiwProps"
                  ></b-img-lazy>
                  <div>
                    <h4>Find a Tool</h4>
                    <label>
                      Search for the tool you're looking for using the search
                      bar
                    </label>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <b-img-lazy
                    alt="Select Dates"
                    :src="require('@/assets/images/calendar-lg.svg')"
                    v-bind="hiwProps"
                  ></b-img-lazy>
                  <div>
                    <h4>Select Dates</h4>
                    <label>
                      Select the amount of days you'd like to rent your tool
                    </label>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <b-img-lazy
                    alt="Checkout"
                    :src="require('@/assets/images/checkout-lg.svg')"
                    v-bind="hiwProps"
                  ></b-img-lazy>
                  <div>
                    <h4>Checkout</h4>
                    <label>
                      Review your information and go for an easy checkout
                    </label>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

      <div v-if="user" class="container">
        <div>
          <h2 class="page-title">Recently Viewed</h2>
          <recently-viewed-jobs-list></recently-viewed-jobs-list>
        </div>
      </div>
    </div>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * Home page
 * ==================================================================================
 **/

import { mapState } from 'vuex'
import MainLayout from '@/layouts/MainLayout'
import Banner from '@/components/Banner'
import RecentlyAddedJobsList from '@/components/lists/RecentlyAddedJobsList'
import RecentlyViewedJobsList from '@/components/lists/RecentlyViewedJobsList'

export default {
  metaInfo: function() {
    return {
      title: 'Home'
    }
  },
  components: {
    container: MainLayout,
    Banner,
    RecentlyAddedJobsList,
    RecentlyViewedJobsList
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  data: function() {
    return {
      hiwProps: {
        width: '90px',
        height: '90px',
        class: 'col-img'
      }
    }
  }
}
</script>
<style scoped lang="scss">
.home-page {
  margin-top: -84px !important; // Header height

  > * {
    margin-bottom: 5rem;
  }

  .home__hiw {
    padding: 40px 0 70px 0;
    background: #fff;

    h4 {
      font-weight: 600;
    }

    .page-title {
      margin-bottom: 3rem;
    }

    &__content {
      max-width: 350px;
      margin: 0 auto;

      > * {
        margin-bottom: 40px;
      }

      img {
        margin-right: 20px;
      }

      label {
        line-height: 1rem;
        max-width: 250px;
        margin-bottom: 0;
      }
    }
  }
}

.home-page--guest {
  .home__hiw {
    margin-bottom: 0 !important;
  }
}

@media (max-width: 768px) {
  .home-page {
    .home__hiw {
      padding: 20px 0;

      h4 {
        font-size: 1.3rem;
        margin-bottom: 2.5px;
      }

      label {
        font-size: 1.05rem;
        line-height: 1.75rem;
        max-width: 90%;
      }

      .page-title {
        margin-bottom: 1.5rem;
      }

      .banner-img {
        width: 100%;
        margin-bottom: 1.5rem;
        border-radius: 3px;
        border: 1px solid #707070;
      }

      .col-img {
        width: 65px;
        width: 65px;
      }

      &__content {
        width: 100%;
        max-width: 100%;

        > div {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
